module.exports = __webpack_public_path__ + "img/ma.36d320bc.svg";